// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import animated from 'animate.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import jQuery from 'jquery'
import {Lazyload, Popup, Icon} from 'vant';
import platConfig from './config';

Vue.use(Lazyload);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(VueI18n)
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.use(animated)
Vue.use(Vant);
Vue.config.productionTip = false
Vue.prototype.$platConfig = platConfig.config;
Vue.component('remote-script', {
  render: function (createElement) {
      var self = this;
      return createElement('script', {
          attrs: {
              type: 'text/javascript',
              src: this.src
          },
          on: {
              load: function (event) {
                  self.$emit('load', event);
              },
              error: function (event) {
                  self.$emit('error', event);
              },
              readystatechange: function (event) {
                  if (this.readyState == 'complete') {
                      self.$emit('load', event);
                  }
              }
          }
      });
  },
  props: {
      src: {
          type: String,
          required: true
      }
  }
});


const i18n = new VueI18n({
  locale: 'en-us',    // 语言标识, 通过切换locale的值来实现语言切换,this.$i18n.locale
  messages: {
    'zh-cn': require('./common/lang/zh'),   // 中文语言包
    'en-us': require('./common/lang/en'), // 英文语言包
    'zh-hk': require('./common/lang/tw'),   // 繁体语言包
    'de': require('./common/lang/de'),   // 德语语言包
    'ru': require('./common/lang/ru'),   //俄语语言包
    'ar': require('./common/lang/ar'),   // 阿拉伯语言包
    'fr': require('./common/lang/fr'),   // 法语语言包
  },
  silentTranslationWarn: true, //隐藏警告
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js